import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import {
  createAnswer,
  createQueation,
  AnswerParams,
  updateFile,
  searchAnswerList,
  getQaList,
  getAnswerList,
  insertOrUpdateQuestion
} from '../../services/QAmanage'


export const createAnswerAsync = createAsyncThunk<
  any,
  AnswerParams,
  RootThunkApi
>('stand/createAnswer', async (params, api) => {
  return sendAsync(createAnswer(params), api)
})

export const updateFileAsync = createAsyncThunk<
  any,
  any,
  RootThunkApi
>('stand/updateFile', async (params, api) => {
  return sendAsync(updateFile(params), api)
})

export const searchAnswerListAsync = createAsyncThunk<
  any,
  { str: string, current: number, size: number },
  RootThunkApi
>('stand/searchAnswerList', async (params, api) => {
  return sendAsync(searchAnswerList(params), api)
})

export const getQaListAsync = createAsyncThunk<
  any,
  { current: number, size: number },
  RootThunkApi
>('stand/getQaList', async (params, api) => {
  return sendAsync(getQaList(params), api)
})

export const getAnswerListAsync = createAsyncThunk<
  any,
  { ids: any },
  RootThunkApi
>('stand/getAnswerList', async (params, api) => {
  return sendAsync(getAnswerList(params), api)
})

export const insertOrUpdateQuestionAsync = createAsyncThunk<
  any,
  any,
  RootThunkApi
>('stand/insertOrUpdateQuestion', async (params, api) => {
  return sendAsync(insertOrUpdateQuestion(params), api)
})